import { createColumnInput, createColumnSelect, createColumnDate } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import {
    createFieldInput,
    createFieldTextArea,
    createFieldSelect,
    createFieldTemplateBuilder,
    createFieldDate,
    createFieldAttachment,
} from "../../../../../components/input/template-builder/template-builder.logic";
import store from "../../../../../store";

export const callLawStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LAW_STATUS", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.law.name"),
            dataIndex: "name",
            customRender: ({ record }) => <div>{record.name}</div>,
            align: "center",
        }),
        createColumnDate({ title: () => i18n.global.t("model.law.startDate"), dataIndex: "startDate", align: "center", search: { visible: () => false } }),
        createColumnSelect({
            title: () => i18n.global.t("model.law.refStatus"),
            dataIndex: "refStatus.id",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callLawStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
        }),
    ];
    return columns;
};

export const createFields = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.law.name")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.name,
                            "onUpdate:value": (value) => (model.name = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}detail`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.law.detail")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.detail,
                            "onUpdate:value": (value) => (model.detail = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}startDate`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.law.startDate"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    { value: model.startDate, "onUpdate:value": (value) => (model.startDate = value), disabled: viewOnly },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}refStatus`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.law.refStatus")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refStatus,
                                        "onUpdate:value": (value) => (model.refStatus = value),
                                        disabled: viewOnly,
                                        list: callLawStatus,
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldAttachment({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: `${prefix}attachments`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.law.attachments"),
                            inputProp: ({ field }) => {
                                return lodash.merge(
                                    {
                                        value: model.attachments,
                                        listType: "picture-card",
                                        showUploadList: { showPreviewIcon: true, showRemoveIcon: false },
                                        multiple: true,
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field, model } })
                                );
                            },
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}endDate`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.law.endDate"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    { value: model.endDate, "onUpdate:value": (value) => (model.endDate = value), disabled: viewOnly },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        })
                    ]})
                }),
            })
        ]
    });
};
